import { useState, useEffect } from 'react';
import { fetchClientFeatures } from './features';

// Loads the current account owner's enabled feature modules and exposes
// hasFeature(key) over them. Mirrors usePermissions() — feature flags gate whole
// modules (per client), permissions gate actions within a module (per role).
//
//   const { hasFeature, loading } = useFeatures();
//   if (hasFeature('material_management')) { ...show the module... }
export function useFeatures() {
  const [features, setFeatures] = useState(() => new Set());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    fetchClientFeatures()
      .then((keys) => { if (active) { setFeatures(keys); setLoading(false); } })
      .catch(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  return { features, loading, hasFeature: (key) => features.has(key) };
}
